import React, { Component } from "react";
import { connect } from 'react-redux';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';

import "./filter.component.css";
import ButtonIcon from "../../button";
import { SelectField } from "../custom-form/select-filter.component";
import { InputField } from "../custom-form/input-filter-component";
import DATEPICKER_OR from "../custom-form/custom-date-picker.component";
import DateRange from "../custom-form/custom-date-range-component";
import CustomSearchableSelect from "../custom-form/custom-searchable-select.component";
import Translation from "../translation/translation.component";
import { MAX_LENGTH, SELECT_OPERATOR } from "../../../constants/external-constants";
import { convertToFormatDate, convertToFormatLocalDate, convertToLocalDateToUTCDate } from "../../../utils/helpers.utils";
import { filterActions } from "../../../store/external/filter-reducer/filter-reducer";
import { bindActionCreators } from "@reduxjs/toolkit";
import { withRouter } from "react-router-dom";

class Filter extends Component {
    constructor(props) {
        super(props);  
        this.AddFilter = this.AddFilter.bind(this);
        this.ResetFilter = this.ResetFilter.bind(this);
        this.HideFilter= this.HideFilter.bind(this);
        this.RemoveItemFilter = this.RemoveItemFilter.bind(this);
        this.FieldChange = this.FieldChange.bind(this);
        this.state = {
           filterList:[],
           startDate: null,
           endDate: null,
           filterSelected: {
               label: "",
               value: "",
               key: 0
           },
           operatorSelected: {
               label: "",
               value: ""
           },
           optionSelected: {
               label: "",
               value: ""
           },
           inputValue: "",  
           copyFilter:[], 
           showFilter:false, 
           showDateRange: false,        
           disableApplyFilter: true,
           disableAddFilter: true,
           disableResetFilter: true,
           disableSelectDate: true,
           disableInputValue: true,
           isFilterApplied: false,
           selectedValue: ''     
        }      
    }

    AddFilter() {
        const { addAction, setFilterData } = this.props;
        const { filterList, filterSelected, operatorSelected, inputValue, optionSelected, startDate, endDate } = this.state;

        var filter = [
            ...filterList,
            {
                filterLabel: filterSelected.label,
                operatorLabel: operatorSelected.label,
                inputValue: inputValue,
                startDate: startDate,
                endDate: endDate,
                optionLabel: optionSelected.label
            }
        ];
        setFilterData(filter);

        var tableFilterModel = {
            Filter: filterSelected.value,
            Operator: operatorSelected.value,
            Option: optionSelected.value,
            Value: inputValue,
            StartDate: startDate ? moment(startDate).format('YYYY-MM-DD') : null,
            EndDate: endDate ? moment(endDate).format('YYYY-MM-DD') : null,
            TimezoneOffset: new Date().getTimezoneOffset()
        };

        addAction(tableFilterModel);

        this.ClearData();
        this.DisableApplyFilter(filter, false);
    }

    ClearData() {
        this.setState({
            filterSelected: {
                label: "",
                value: "",
                key: 0
            },
            operatorSelected: {
                label: "",
                value: ""
            },
            optionSelected: {
                label: "",
                value: ""
            },
            inputValue: "",
            startDate: null,
            endDate: null,
            disableAddFilter: true,
            disableInputValue: true,
            disableSelectDate: true,
            showDateRange: false
        });
    }

    ResetFilter() {
        const { applyAction, resetFilter } = this.props;

        this.ClearData();
        this.setState({
            disableApplyFilter: true,
            disableResetFilter: true,
            isFilterApplied: false,
            showFilter: false
        });
        resetFilter();
        applyAction(false,  true);
    }

    ApplyFilter() {
        const { applyAction, filterData } = this.props;

        var enableFilter = filterData.length > 0;

        this.setState({
            disableApplyFilter: !enableFilter,
            disableResetFilter: !enableFilter,
            isFilterApplied: enableFilter
        })
        applyAction(enableFilter);
    }

    HideFilter() {
        this.setState({showFilter:!this.state.showFilter})
    }
    onChangeDates = (dates) => {
        const [start, end] = dates;
        const { filterSelected, operatorSelected, optionSelected, inputValue } = this.state;

        var filter = {
            filterSelected: filterSelected,
            operatorSelected: operatorSelected,
            optionSelected: optionSelected,
            inputValue: inputValue,
            startDate: start,
            endDate: end
        };
        var isDisableAddFilter = this.DisableAddFilter(filter);

        this.setState({
            startDate: start,
            endDate: end,
            disableAddFilter: isDisableAddFilter,
        });
      };
    RemoveItemFilter(removeIndex) {
        const { isFilterApplied } = this.state;
        const { removeAction, removeFilterData, filterData } = this.props;
        let filterList = filterData.filter((item, index) => index !== removeIndex)
        removeAction(removeIndex);
        removeFilterData(removeIndex);
        this.DisableApplyFilter(filterList, isFilterApplied);
    }

    FieldChange(e, name) {
        const { filterSelected, operatorSelected, optionSelected, inputValue, startDate, endDate } = this.state;
        const { FilterList } = this.props.data;
        var elObj = e.target;
        var mapValue;
        if (elObj.tagName == "SEARCHABLE-SELECT") {
            mapValue = {
                label: e.text,
                value: e.value,
                key: e.key
            };
        }
        else if (elObj.tagName == "SELECT") {
            var getvalue = elObj.options[elObj.selectedIndex].value;
            var gettext = elObj.options[elObj.selectedIndex].text;

            mapValue = {
                label: gettext,
                value: getvalue
            };
        }
        else {
            mapValue = elObj.value;
        }

        var filterMap = {
            filterSelected: filterSelected,
            operatorSelected: operatorSelected,
            optionSelected: optionSelected,
            inputValue: inputValue,
            startDate: startDate,
            endDate: endDate
        };

        if (name == 'filter') {
            filterMap = {
                ...filterMap,
                filterSelected: mapValue
            };
        }
        else if (name == 'operator') {
            filterMap = {
                ...filterMap,
                operatorSelected: mapValue
            };
        }
        else if (name == 'value') {
            filterMap = {
                ...filterMap,
                inputValue: mapValue
            };
        }
        else if (name == 'option') {
            filterMap = {
                ...filterMap,
                optionSelected: mapValue
            };
        }

        var isDateField = FilterList?.findIndex(r => r.FilterName == filterMap.filterSelected.value && r.FieldType.includes('Date')) > -1;
        var isDisableInputValue = FilterList?.findIndex(r => r.FilterName == filterMap.filterSelected.value && !r.FieldType.includes('Date')) == -1;
        var isDatePicker = isDateField && filterMap.operatorSelected.value != 'Between';
        var isDateRange = isDateField && filterMap.operatorSelected.value == 'Between';

        if (!isDateField && filterMap.operatorSelected.value == 'Between') {
            mapValue = {
                label: 'Contains',
                value: 'Contains'
            };
            filterMap = {
                ...filterMap,
                operatorSelected: mapValue
            };
        }
        else if (isDateField && (filterMap.operatorSelected.value == 'Contains' || filterMap.operatorSelected.value == 'DoesNotContain')) {
            mapValue = {
                label: 'Between',
                value: 'Between'
            };
            isDateRange = true;
            filterMap = {
                ...filterMap,
                operatorSelected: mapValue
            };
        }
        var mapState = {
            ...filterMap,
            inputValue: isDateField ? '' : filterMap.inputValue,
            startDate: isDateField ? filterMap.startDate : null,
            endDate: isDateRange ? filterMap.endDate : null,
            disableInputValue: isDisableInputValue,
            disableSelectDate: !isDatePicker,
            showDateRange: isDateRange
        };

        var isDisableAddFilter = this.DisableAddFilter(mapState);
        this.setState({
            ...mapState,
            disableAddFilter: isDisableAddFilter,
        });        
    }

    DisableAddFilter = (filter) => {       
        const { filterSelected, operatorSelected, optionSelected, inputValue, startDate, endDate } = filter;
  
        var hascondition = filterSelected?.value?.length > 0 && operatorSelected?.value?.length > 0 && optionSelected?.value?.length > 0;
        var hasvalue = inputValue?.trim().length > 0 || (startDate != null && operatorSelected.value !== SELECT_OPERATOR.Between) || (startDate != null && endDate != null);

        return !hascondition || !hasvalue;
    }

    DisableApplyFilter(filterList, isFilterApplied) {
        var disable = filterList.length == 0 && !isFilterApplied;
        this.setState({
            disableApplyFilter: disable,
            disableResetFilter: disable
        });
    }

    GetOperatorList = () => {
        const { filterSelected } = this.state;
        const { FilterList, Operatorlist } = this.props.data;
        if (FilterList) {
            var isDateField = FilterList.findIndex(r => r.FilterName === filterSelected.value && r.FieldType.includes('Date')) > -1;

            return Operatorlist
            .filter(item => item.FilterName !== 'StartsWith')
            .filter(item => isDateField ? !item.FilterName.includes('Contain') : !item.FilterName.includes('Between'));
        }
    }

    SelectDatePicker(date) {
        const { filterSelected, operatorSelected, optionSelected, inputValue } = this.state;

        var filter = {
            filterSelected: filterSelected,
            operatorSelected: operatorSelected,
            optionSelected: optionSelected,
            inputValue: inputValue,
            startDate: date
        };
        var isDisableAddFilter = this.DisableAddFilter(filter);

        this.setState({
            startDate: date,
            disableAddFilter: isDisableAddFilter,
        });
    }

    handleSelectChange = (value) => {
        this.setState({ selectedValue: value });
    };

    filterValueLabel = (objValue) => {
        const { activeDateFormat } = this.props;
        const { inputValue, startDate, endDate, filterLabel, operatorLabel, optionLabel } = objValue;

        var labelValue = inputValue;
        if (startDate != null) {
            labelValue = convertToFormatLocalDate(startDate, activeDateFormat.Name);

            if (endDate != null)
                labelValue = `${labelValue} - ${convertToFormatLocalDate(endDate, activeDateFormat.Name)}`;
        }

        return `${filterLabel} ${operatorLabel} ${labelValue} ${optionLabel}`;
    }
    getBasePath(path) {
 
        const segments = path.split('/');
        if (segments.length > 2) {
            return `${segments[1]}/${segments[2]}/${segments[3]}`;
        }
        return path;
    }

    isNavigatingToDifferentPage(location) {
        const currentPath = this.props.location.pathname;
        const newPath = location.pathname;

        const currentBasePath = this.getBasePath(currentPath);
        const newBasePath = this.getBasePath(newPath);
        
        return currentBasePath !== newBasePath;
    }

    componentDidMount() {
        const { filterData, history } = this.props;
        this.setState({ disableResetFilter: filterData.length === 0 });

        this.unlisten = history.listen((location, action) => {
            if (this.isNavigatingToDifferentPage(location)) {
                this.ResetFilter()
            }
        });
    }
    componentDidUpdate(prevProps) {
        if(prevProps.tabSelectedAction) {
            if (prevProps.tabSelectedAction !== this.props.tabSelectedAction){
                this.ClearData();
            }
        }
    }

    componentWillUnmount() {

        if (this.unlisten) {
            this.unlisten();
        }
    }
    render() {
        const { filterList, startDate, endDate, disableApplyFilter, disableAddFilter, disableResetFilter, disableSelectDate, disableInputValue, showDateRange } = this.state;     
        const { FilterList, OptionList } = this.props.data;
        const { filterData } = this.props;
    
        return(
            <div className="filter-wrapper">
                <div className={`component-container legend-center second-col-container ${this.props.customClassName}`}>
                    <div className="component-filter-header">
                        <div className="component-filter-header-container">
                            <div className="filter-header-title">
                                Filter
                            </div>
                            {
                                this.state.showFilter ?
                                <div className="hide-filter-result-container">
                                    <div className="hide-filter-length">
                                            {filterData.length}
                                    </div>
                                </div>
                                :
                                <div className="filter-result-container">                           
                                    {                               
                                        filterData.map((item, index) => {
                                            return <p key={index} className="filter-header-list-item">{this.filterValueLabel(item)} <span onClick={() => this.RemoveItemFilter(index)}></span></p>
                                        })
                                    }
                                </div>
                            }
                                                
                        </div>
                        <div className="component-hide-filter" onClick={this.HideFilter}>
                            {this.state.showFilter ? "+ Show Filter" : "- Hide Filter"}                       
                        </div>                    
                    </div>
                    <div className="horizontal-separator"></div>
                    <div className="component-form-filter">
                        <CustomSearchableSelect
                            label={<Translation translationKey={'select_filter'} />}
                            options={FilterList? FilterList : []}
                            selected={this.state.filterSelected.key}
                            onChange={(e) => this.FieldChange(e, 'filter')}
                            placeholder="Select..."
                            requiredField={this.props.requiredField}
                            tagName='SEARCHABLE-SELECT'
                            isMainFilter={true}
                            optionLabelKey={{
                                Key: 'FilterId',
                                Value: 'FilterName'
                            }}
                        />
                        {/* Select Operator */}
                        <SelectField
                            label={<Translation translationKey={'select_operator'} />}
                            requiredField={this.props.requiredField}
                            placeholder="Select..."
                            options={this.GetOperatorList()}
                            selected={this.state.operatorSelected.value}
                            onChange={(e) => this.FieldChange(e, 'operator')}
                        />

                        {/* Value Input */}
                        <InputField
                            label={<Translation translationKey={'value'} />}
                            requiredField={this.props.requiredField}
                            placeholder="Enter..."
                            inputValue={this.state.inputValue}
                            onChange={(e) => this.FieldChange(e, 'value')}
                            isDisable={disableInputValue}
                            maxLength={MAX_LENGTH.limit_255}
                        />

                        {/* Select Option */}
                        <SelectField
                            label={<Translation translationKey={'select_option'} />}
                            requiredField={this.props.requiredField}
                            placeholder="Select..."
                            options={OptionList}
                            selected={this.state.optionSelected.value}
                            onChange={(e) => this.FieldChange(e, 'option')}
                        />  
                        { showDateRange ? 
                        <DateRange label={<Translation translationKey={'date'} />}
                            startDate={startDate} 
                            endDate={endDate} 
                            dateSelected={startDate}
                            onChange={this.onChangeDates}
                            placeholder="Select Date Range"
                            requiredField={this.props.requiredField}
                            dateOnly={true}
                            dateRangeWrapperClass="filter-date-range"
                        /> :
                            <DATEPICKER_OR label={<Translation translationKey={'date'} />} requiredField={this.props.requiredField} placeholder="Select Date" startDate={startDate} dateSelected={startDate} selectedDate={(date) => this.SelectDatePicker(date)} isDisable={disableSelectDate} dateOnly={true} />

                        }

                        <ButtonIcon onClick={this.AddFilter} iconLeft="file-plus" iconSize="17px" customClassName="header-option-list header-filter-button" labelName="Add Filter" isDisable={disableAddFilter} />
                    </div>
                    <div className="filter-button-container">
                        <ButtonIcon onClick={this.ResetFilter} customClassName="header-option-list header-filter-button" labelName="Reset Filter" isDisable={disableResetFilter} />
                        <ButtonIcon onClick={() => this.ApplyFilter()} customClassName="header-option-list header-filter-button" labelName="Apply Filter" isDisable={disableApplyFilter} />
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(connect(
    state => {
        const { activeDateFormat } = state.adminSetting;
        const { filter: { filterData } } = state;
        return {
            activeDateFormat,
            filterData
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, filterActions),
        dispatch
    )
)(Filter))